// extracted by mini-css-extract-plugin
export default {"Piece":"Piece_Piece__6Cjud"};